// 标记
export default {
    marker: 'marker',
    folder: 'folder',
    creationTime: 'Creation time',
    sameDay: 'same day',
    thisWeek: 'This week',
    thisMonth: 'This month',
    thisYear: 'This year',
    all: 'all',
    place: 'place',
    addPoints: 'Add Points',
    addLine: 'Add Line',
    addPolygon: 'Add Polygon',
    markerInfo: 'Dimension information',
    lng: 'longitude',
    lat: 'latitude',
    alt: 'altitude',
    color: 'color',
    icon: 'icon',
    remarks: 'remarks',
    unnamedLine: 'Unnamed line',
    linetype: 'Linetype',
    lineWidth: 'line width',
    solidLine: 'Solid line',
    dottedLine: 'Dotted line',
    dashDot: 'dash dot',
    transparent: 'transparent',
    arrowPosition: 'Arrow Position',
    startingPoint: 'starting point',
    end: 'End',
    arrowDirection: 'Arrow direction',
    forward: 'Forward',
    reverse: 'reverse',
    shape: 'shape',
    unnamedFaces: 'Unnamed faces',
    sideLength: 'Side length',
    long: 'long',
    wide: 'wide',
    numberSides: 'Number of sides',
    radius: 'radius',
    cancel: 'cancel',
    complete: 'complete',
    clickCut: 'Click the map to start cropping',
    areaName: 'Area Name',
    enterName: 'Please enter the area name',
    enterContent: 'Please enter the content',
    save: 'save',
    delete: 'delete',
    originalArea: 'Original area',
    determine: 'determine',
    tips: 'Tips',
    search:'search',
    importKML:'Import KML',
    exportKML:'Export KML',
    addFolders:'add folders',
    share:'share',
    unnamedPoint:'Unnamed point',
    enterNameSearch:'Please enter a name to search',
    fileImport:'File import',
    destinationFolder:'Destination Folder',
    edit:'edit',
    showHide:'Show/Hide',
    createdBy:'Created by',
    editFolder:'Edit Folder',
    addFolder:'Add Folder',
    enterFolderName:'Please enter a folder name',
    quickSharing:'Quick sharing',
    onlineEquipment:'Online equipment',
    uav:'UAV',
    rtkStation:'RTK base station',
    refresh:'Refresh',
    copy:'copy',
    use:'use',
    sharedUsers:'Shared Users',
    more:'more',
    pleaseSelect:'Please Select',
    nothing:'nothing',
    folderName:'Folder Name',
    triangle:'triangle',
    rectangle:'rectangle',
    polygon:'polygon',
    circular:'circular',
    free:'free',
    enterDeviceSearch:'Please enter the device name to search',
    notLocated:'Not located',
    singlePointPositioning:'Single point positioning',
    diffPositioning:'Differential positioning',
    fixedUnposition:'Fixed unposition',
    floatingPointRelocation:'Floating point relocation',
    inertialNavigationPositioning:'Inertial navigation positioning',
    setPositioning:'Set Positioning',
    noPositioning:'No positioning',
    gpsPositioningError:'GPS positioning error',
    rtkSinglePointPositioning:'RTK single point positioning',
    rtkDiffPositioning:'RTK differential positioning',
    rtkFloatingPointRelocation:'RTK floating point relocation',
    rtkFixedPositioning:'RTK fixed positioning',
    gpsPositioning:'GPS positioning',
    mobilePhone:'Mobile Phone',
    importRouteList:'Import Route List',
    delTip:'The mark cannot be restored after deletion. Do you want to continue?',
    pleaseSelectAtLeastOneTag:'Please select at least one tag',
    sharingSuccessful:'Sharing successful',
    markingSurface:'Marking surface',
    dbclickCut:'Double click on the map or click on the last point to complete cropping',
    cutAtLeastOnce:'Cut at least once',
    markingLine:'marking Line',
    markPoint:'Mark Points'


}
